/*!
 * Copyright 2019 yangjunbao <yangjunbao@shimo.im>. All rights reserved.
 * @since 2019-07-09 12:02:42
 */
import { __assign, __awaiter, __generator } from "tslib";
import { app } from '@ekuaibao/whispered';
import { initDatafluxRum } from '../dataflux-rum';
import { addNcpcCode } from '@ekuaibao/lib/lib/addNcpcCode';
import { goto } from '../../lib/lib-util';
import { callback, preloadMfePlugin, startFmpPrefetch, startMfeLoad } from '../index.v0';
import { newHomeConfig } from '../newHomeConfig';
import { eKuaibaoSDK } from '@ekuaibao/sdk-bridge/sdk/ekuaibao';
import registerAPI from '../registerAPI';
import initializeTitle from '../initializeTitle';
import registerHandler from '../registerHandler';
import initPlatformInfo from '../initPlatformInfo';
import { initRoute } from '../initRoute';
import { initColors } from '../initColors';
import setNetworkAdapter from '../setNetworkAdapter';
import qs from 'qs';
import initLogger from '../../logger/initLogger';
import { anonymousUser, initFeatBit, switchFeatBitUser } from '../../lib/featbit';
import { initializeI18n, setStaffDefaultLanguage } from '../i18n-initialize';
import * as SW from '../../lib/swEntrance';
require('../../styles/app.less');
window.__PLANTFORM__ = 'APP';
initDatafluxRum();
initLogger();
function startup() {
    var params = qs.parse(location.search.slice(1));
    if (params === null || params === void 0 ? void 0 : params.billentry) {
        window.__SUB_PLANNTFORM__ = 'BILLENTRY';
    }
    app.use({
        id: '@app',
        onready: function () {
            addNcpcCode();
        }
    });
    callback();
}
var initPromise = null;
export var appDataInitialize = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                initPromise = appInitialize();
                return [4, initPromise];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
function appInitialize() {
    return __awaiter(this, void 0, void 0, function () {
        var idpBaseUri, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    preloadMfePlugin();
                    initColors();
                    app.container.set('IDeviceType', 'DESKTOP');
                    app.container.set('ISMessageEntry', false);
                    app.sdk = app.container.get(eKuaibaoSDK);
                    idpBaseUri = window.getEnvConfigValue('idpDomain', app.sdk.idpInfo.idpBaseUri);
                    app.sdk.idpInfo = __assign(__assign({}, app.sdk.idpInfo), { idpBaseUri: idpBaseUri });
                    registerHandler();
                    registerAPI();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    return [4, Promise.all([
                            app.sdk.initialize(),
                            initFeatBit(anonymousUser()),
                            initPlatformInfo(),
                            initializeI18n()
                        ])];
                case 2:
                    _a.sent();
                    initRoute();
                    return [4, switchFeatBitUser()];
                case 3:
                    _a.sent();
                    return [4, newHomeConfig({ needInitI18n: false, needInitFeatBit: false })];
                case 4:
                    _a.sent();
                    startFmpPrefetch();
                    startMfeLoad();
                    setStaffDefaultLanguage();
                    setNetworkAdapter();
                    initializeTitle();
                    SW.start();
                    return [3, 6];
                case 5:
                    e_1 = _a.sent();
                    if ((e_1 === null || e_1 === void 0 ? void 0 : e_1.errorCode) === 401) {
                        goto('/login');
                    }
                    console.error(e_1);
                    return [3, 6];
                case 6: return [2];
            }
        });
    });
}
export function bootstrap() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!initPromise) return [3, 2];
                    return [4, initPromise];
                case 1:
                    _a.sent();
                    initPromise = null;
                    _a.label = 2;
                case 2:
                    startup();
                    return [2];
            }
        });
    });
}
